export enum AccountAppType {
  ClaimSnap = 1,
  AgentSnap = 2,
  DualApp = 3,
}
